let scrollPos = window.scrollY; // Initialize with window.scrollY
let headerHeight = document.querySelector('.jsSiteHeader')?.clientHeight || 100; // Fallback if .jsSiteHeader is missing
let scrollTimeout;

// Add scroll event listener without debouncing
window.addEventListener('scroll', () => {
    requestAnimationFrame(handleScroll); // Use requestAnimationFrame for smoother updates
});

function goingUp() {
    document.documentElement.classList.add('going-up');
    document.documentElement.classList.remove('going-down');
}

function goingDown() {
    document.documentElement.classList.add('going-down');
    document.documentElement.classList.remove('going-up');
}

function handleScroll() {
    // Note if scrolling starts
    document.documentElement.classList.add('is-scrolling');

    // Clear any existing timeout
    clearTimeout(scrollTimeout);

    // Set timeout to remove 'is-scrolling' class after scrolling stops
    scrollTimeout = setTimeout(() => {
        document.documentElement.classList.remove('is-scrolling');
    }, 100);

    // Get current scroll position
    const currentScrollPos = window.scrollY;

    // Debugging: Log scroll position and at-top state
    console.log('scrollY:', currentScrollPos, 'at-top:', currentScrollPos <= headerHeight);

    // Check if at or near the top (account for bounce effect)
    if (currentScrollPos <= headerHeight) {
        goingUp();
        document.documentElement.classList.add('at-top');
    } else {
        document.documentElement.classList.remove('at-top');
        // Detect scroll direction
        if (currentScrollPos < scrollPos) {
            goingUp();
        } else {
            goingDown();
        }
    }

    // Update scroll position
    scrollPos = currentScrollPos;
}

// Handle focus on header clickables
const headerLinks = document.querySelectorAll('.jsSiteHeader a, .jsSiteHeader button, .jsSiteHeader input');
headerLinks.forEach((link) => {
    link.addEventListener('focus', () => {
        goingUp();
    });
});

// Initial call to set correct state
handleScroll();